var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24873 9.55971L12.832 6.94062M8.24873 12.4406L12.832 15.0597M18.5612 5.50016C18.5612 7.14552 17.2274 8.47933 15.582 8.47933C13.9367 8.47933 12.6029 7.14552 12.6029 5.50016C12.6029 3.85481 13.9367 2.521 15.582 2.521C17.2274 2.521 18.5612 3.85481 18.5612 5.50016ZM18.5612 16.5002C18.5612 18.1455 17.2274 19.4793 15.582 19.4793C13.9367 19.4793 12.6029 18.1455 12.6029 16.5002C12.6029 14.8548 13.9367 13.521 15.582 13.521C17.2274 13.521 18.5612 14.8548 18.5612 16.5002ZM8.47787 11.0002C8.47787 12.6455 7.14405 13.9793 5.4987 13.9793C3.85335 13.9793 2.51953 12.6455 2.51953 11.0002C2.51953 9.35484 3.85335 8.021 5.4987 8.021C7.14405 8.021 8.47787 9.35484 8.47787 11.0002Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.ea8d0dbf3cea3336f2e13b42b36c8268.svg";
export { ForwardRef as ReactComponent };